var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPLogoTsmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gfb-logo-tsmc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gfb-logo-tsmc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-1",
    transform: "translate(20.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.415884, 0.000000)",
    stroke: "#323237"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8090666,76.6589479 L40.3758316,76.7777875 L57.4555929,76.7777875 C71.6007133,70.4867179 81.5287017,56.4042293 81.5287017,40.1529186 C81.5211577,18.0487592 63.1966257,0 40.7907551,0 C18.3848844,0 0,18.0487592 0,40.160346 C0,56.3299546 9.76201907,70.3381685 23.8090666,76.6589479 Z",
    id: "Path",
    strokeWidth: 0.7275
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28338248,21.4505418 L8.28338248,15.9542118 C6.95562719,17.6773855 5.77120911,19.5193988 4.73012825,21.4505418 L8.28338248,21.4505418 L8.28338248,21.4505418 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1187161,11.3788885 L69.1187161,15.3228766 L72.747411,15.3228766 C71.6233454,13.9339392 70.4162952,12.611849 69.1187161,11.3788885 L69.1187161,11.3788885 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8553597,0.802167074 L48.8553597,3.05269137 L52.8235375,3.05269137 L52.8235375,1.80487592 C51.5259584,1.40379238 50.1982031,1.0695561 48.8553597,0.809594547 L48.8553597,0.802167074 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 15.2783118,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 21.4505418,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 52.1111499,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 12.4099856,
    y: 58.2239602,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 21.4505418,
    width: 3.93800151,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 27.5559245,
    width: 3.93800151,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 33.7281545,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 39.8409647,
    width: 3.93800151,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 45.9983397,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 52.1111499,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 8.35882313,
    y: 58.2239602,
    width: 3.93800151,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 4.33029285,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 4.33029285,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 4.33029285,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 4.33029285,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 16.4762362,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 20.5349427,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 20.5349427,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 20.5349427,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 9.16550157,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 24.5408408,
    y: 15.2783118,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 21.4505418,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 52.1111499,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 24.5408408,
    y: 58.2239602,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 24.5408408,
    y: 64.3961901,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 24.5408408,
    y: 70.4941454,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 3.00069906,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 28.5995474,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 28.5995474,
    y: 70.4941454,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 9.16550157,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 3.00069906,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 15.2783118,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 21.4505418,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 52.1111499,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 58.2239602,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 64.3961901,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 32.665798,
    y: 70.4941454,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 36.7395926,
    y: 3.00069906,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 36.7395926,
    y: 70.4941454,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 3.00069906,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 40.7907551,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 40.7907551,
    y: 70.4941454,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 9.16550157,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 3.00069906,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 15.2783118,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 21.4505418,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 52.1111499,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 58.2239602,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 64.3961901,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 44.8041972,
    y: 70.4941454,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 9.16550157,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 3.00069906,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 15.2783118,
    width: 3.96817777,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 21.4505418,
    width: 3.96817777,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 27.5559245,
    width: 3.96817777,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 33.7281545,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 39.8409647,
    width: 3.96817777,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 45.9983397,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 52.1111499,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 58.2239602,
    width: 3.96817777,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 64.3961901,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 48.8553597,
    y: 70.4941454,
    width: 3.96817777,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 9.16550157,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 15.2783118,
    width: 3.93800151,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 21.4505418,
    width: 3.93800151,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 27.5559245,
    width: 3.93800151,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 33.7281545,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 39.8409647,
    width: 3.93800151,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 45.9983397,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 52.1111499,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 58.2239602,
    width: 3.93800151,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 64.3961901,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 52.9216103,
    y: 70.4941454,
    width: 3.93800151,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 56.9878609,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 56.9878609,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 56.9878609,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 9.16550157,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 15.2783118,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 21.4505418,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 27.5559245,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 33.7281545,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 39.8409647,
    width: 3.95308964,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 45.9983397,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 52.1111499,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fill: "#323237",
    fillRule: "nonzero",
    x: 60.993759,
    y: 58.2239602,
    width: 3.95308964,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 60.993759,
    y: 64.3961901,
    width: 3.95308964,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 15.2783118,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 21.4505418,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 52.1111499,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 65.0600096,
    y: 58.2239602,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 21.4505418,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 52.1111499,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 69.1187161,
    y: 58.2239602,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 73.1849667,
    y: 27.5559245,
    width: 3.94554557,
    height: 6.17222999
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 73.1849667,
    y: 33.7281545,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 73.1849667,
    y: 39.8409647,
    width: 3.94554557,
    height: 6.15737504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    x: 73.1849667,
    y: 45.9983397,
    width: 3.94554557,
    height: 6.16480252
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero",
    points: "81.0685138 45.9909123 77.1833208 45.9983397 77.1833208 39.8409647 81.5136136 39.8186823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35882313,15.8873646 L8.35882313,21.4505418 L12.2968246,21.4505418 L12.2968246,15.2783118 L8.83409917,15.2783118 C8.66812976,15.4788535 8.50970441,15.6793953 8.35882313,15.8873646 L8.35882313,15.8873646 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28338248,21.4505418 L4.73012825,21.4505418 C4.59433509,21.6956484 4.45854194,21.940755 4.33029285,22.2007165 L4.33029285,27.6153443 L8.28338248,27.6153443 L8.28338248,21.4579692 L8.28338248,21.4505418 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1305123,22.081877 C77.0248954,21.8664803 76.9117344,21.658511 76.7985735,21.4505418 L73.1849667,21.4505418 L73.1849667,27.6079168 L77.1305123,27.6079168 L77.1305123,22.081877 L77.1305123,22.081877 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0642617,15.7388151 C72.9511007,15.5828382 72.8228517,15.4268612 72.6946026,15.2708843 L69.1111721,15.2708843 L69.1111721,21.4431143 L73.0567176,21.4431143 L73.0567176,15.7313876 L73.0642617,15.7388151 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.180646,3.00069906 L52.9216103,3.00069906 L52.9216103,9.16550157 L56.8596118,9.16550157 L56.8596118,3.28294303 C56.640834,3.18638588 56.406968,3.0972562 56.180646,3.00069906 L56.180646,3.00069906 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4863864,1.87915065 C27.384953,2.22824187 26.2986078,2.62189794 25.2273507,3.05269137 L28.4863864,3.05269137 L28.4863864,1.87915065 L28.4863864,1.87915065 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5995474,1.84944075 L28.5995474,3.05269137 L32.552637,3.05269137 L32.552637,0.824449493 C31.2173376,1.10669346 29.8971264,1.44835722 28.5995474,1.84201328 L28.5995474,1.84944075 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.665798,0.809594547 L32.665798,3.05269137 L36.6113435,3.05269137 L36.6113435,0.207969242 C35.2835882,0.341663754 33.9709211,0.542205523 32.665798,0.802167074 L32.665798,0.809594547 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6851382,0.00742747291 C39.3422948,0.00742747291 38.0371717,0.0742747291 36.7320486,0.207969242 L36.7320486,3.05269137 L40.6851382,3.05269137 L40.6851382,0.00742747291 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7363007,3.05269137 L44.7363007,0.193114296 C43.4387216,0.0742747291 42.1185104,0 40.783211,0 L40.783211,3.05269137 L44.7363007,3.05269137 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8041972,0.200541769 L44.8041972,3.05269137 L48.7497428,3.05269137 L48.7497428,0.779884656 C47.4521638,0.519923104 46.1394966,0.326808808 44.8041972,0.200541769 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9216103,1.82715834 L52.9216103,3.05269137 L56.3315273,3.05269137 C55.2074618,2.60704299 54.0833962,2.18367704 52.9216103,1.82715834 L52.9216103,1.82715834 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9409506,5.30321566 C59.6584596,4.58275079 58.3457925,3.9217057 56.9878609,3.34236281 L56.9878609,9.17292905 L60.9409506,9.17292905 L60.9409506,5.30321566 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.993759,5.33292555 L60.993759,9.16550157 L64.9468486,9.16550157 L64.9468486,7.87312129 C63.6794459,6.95211465 62.3592346,6.10538273 60.993759,5.33292555 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0600096,7.95482349 L65.0600096,9.16550157 L66.629175,9.16550157 C66.1161786,8.74956309 65.5880941,8.34847955 65.0600096,7.95482349 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.629175,9.16550157 L65.0600096,9.16550157 L65.0600096,15.3303041 L69.0055552,15.3303041 L69.0055552,11.2749039 C68.2436047,10.5470115 67.459022,9.84140161 66.636719,9.16550157 L66.629175,9.16550157 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1849667,15.8873646 L73.1849667,21.4505418 L76.7985735,21.4505418 C75.7348604,19.4896889 74.5278102,17.6328207 73.1849667,15.8873646 L73.1849667,15.8873646 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1833208,22.1932891 L77.1833208,27.6079168 L79.4691722,27.6079168 C78.8430149,25.7361936 78.0735203,23.9238902 77.1833208,22.1932891 L77.1833208,22.1932891 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4616281,27.5559245 L77.1833208,27.5559245 L77.1833208,33.7281545 L80.9930732,33.7281545 C80.6460462,31.6113247 80.1255058,29.5539147 79.4540841,27.5559245 L79.4616281,27.5559245 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6653179,52.1111499 L77.1833208,52.1111499 L77.1833208,58.0976931 C78.1640491,56.1814051 79.0165284,54.1834149 79.6653179,52.1111499 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1849667,58.2239602 L73.1849667,64.3961901 L73.215143,64.3961901 C74.7013236,62.4650472 75.9989027,60.3927822 77.1229682,58.2239602 L73.1849667,58.2239602 L73.1849667,58.2239602 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1187161,68.9343761 C70.5370002,67.582576 71.8572114,66.1342188 73.0642617,64.581877 L73.0642617,64.3961901 L69.1187161,64.3961901 L69.1187161,68.9343761 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0600096,70.5609927 L67.3307729,70.5609927 C67.9116659,70.0707794 68.4548385,69.5582838 69.0055552,69.0457882 L69.0055552,64.3961901 L65.0600096,64.3961901 L65.0600096,70.5609927 L65.0600096,70.5609927 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0600096,70.4941454 L65.0600096,72.3510136 C65.8521363,71.7716707 66.636719,71.147763 67.3911254,70.4941454 L65.0600096,70.4941454 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.993759,74.9580566 C62.3592346,74.1855994 63.6794459,73.3611499 64.9468486,72.4401433 L64.9468486,70.4867179 L60.993759,70.4867179 L60.993759,74.9580566 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9878609,76.6589479 L57.6668267,76.6589479 C58.7908923,76.1613072 59.8847816,75.5893918 60.9409506,74.9877665 L60.9409506,70.4867179 L56.9878609,70.4867179 L56.9878609,76.6515204 L56.9878609,76.6589479 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4880324,70.4941454 L20.5349427,70.4941454 L20.5349427,74.9877665 C21.5986558,75.5893918 22.685001,76.1613072 23.8090666,76.6589479 L24.4880324,76.6589479 L24.4880324,70.4941454 L24.4880324,70.4941454 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4762362,72.3807235 C17.7360949,73.3091576 19.0563062,74.1484621 20.4293258,74.9209193 L20.4293258,70.4941454 L16.4762362,70.4941454 L16.4762362,72.3807235 L16.4762362,72.3807235 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3630752,72.2990213 L16.3630752,70.4941454 L14.0847678,70.4941454 C14.8240861,71.1254806 15.5860366,71.7271059 16.3630752,72.2990213 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4099856,68.9789409 C12.9757904,69.513719 13.5566834,70.048497 14.1526644,70.5609927 L16.3555312,70.5609927 L16.3555312,64.3961901 L12.4099856,64.3961901 L12.4099856,68.9789409 L12.4099856,68.9789409 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35882313,64.4927473 C9.55078527,66.0376617 10.8860846,67.5083013 12.2968246,68.8675288 L12.2968246,64.3961901 L8.35882313,64.3961901 L8.35882313,64.4927473 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28338248,58.2239602 L4.37555723,58.2239602 C5.49207873,60.3927822 6.78965777,62.4724747 8.26829436,64.3961901 L8.27583842,64.3961901 L8.27583842,58.2239602 L8.28338248,58.2239602 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23222001,45.9983397 L0.437555723,45.9983397 C0.754406419,48.1151695 1.24477059,50.1725795 1.87847198,52.1631423 L4.23222001,52.1631423 L4.23222001,45.9983397 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23222001,57.9268612 L4.23222001,52.1185774 L1.86338386,52.1185774 C2.49708525,54.1314226 3.29675605,56.0551381 4.23222001,57.9268612 L4.23222001,57.9268612 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23222001,33.7281545 L0.543172622,33.7281545 C0.437555723,34.3223523 0.362115081,34.9314051 0.279130375,35.5404579 L0.0603525135,39.9152394 L4.23222001,39.892957 L4.23222001,33.7281545 L4.23222001,33.7281545 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23222001,33.7281545 L4.23222001,27.5559245 L2.08216172,27.5559245 C1.41828407,29.5539147 0.890199575,31.6113247 0.543172622,33.7281545 L4.23222001,33.7281545 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23222001,27.6079168 L4.23222001,22.4012583 C3.39482889,24.0798672 2.66305466,25.8178958 2.05952952,27.6079168 L4.23222001,27.6079168 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2968246,15.3303041 L12.2968246,11.4903006 C11.04451,12.6935512 9.87518003,13.9859315 8.79637885,15.3303041 L12.2968246,15.3303041 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4099856,15.3303041 L16.3555312,15.3303041 L16.3555312,9.16550157 L14.9070708,9.16550157 C14.0319594,9.86368403 13.2096564,10.6138588 12.4099856,11.386316 L12.4099856,15.3303041 L12.4099856,15.3303041 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3630752,8.05138064 C15.865167,8.41532681 15.3823469,8.79412793 14.9146149,9.16550157 L16.3630752,9.16550157 L16.3630752,8.05138064 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4762362,7.96225096 L16.4762362,9.16550157 L20.4293258,9.16550157 L20.4293258,5.40720028 C19.0487621,6.18708494 17.7360949,7.03381685 16.4762362,7.96225096 L16.4762362,7.96225096 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4880324,3.3720727 C23.1301008,3.96627053 21.8098896,4.61988815 20.5349427,5.3477805 L20.5349427,9.17292905 L24.4880324,9.17292905 L24.4880324,3.3720727 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5408408,9.16550157 L28.4863864,9.16550157 L28.4863864,3.00069906 L25.3706879,3.00069906 C25.0991016,3.11953862 24.8199712,3.22352324 24.5408408,3.34236281 L24.5408408,9.16550157 L24.5408408,9.16550157 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1364104,34.678871 C81.091146,34.3594897 81.0458816,34.0401084 80.9930732,33.720727 L77.1833208,33.720727 L77.1833208,39.8855295 L81.5136136,39.9226669 L81.1364104,34.678871 L81.1364104,34.678871 Z",
    id: "Path",
    strokeWidth: 0.7125,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1833208,45.9983397 L77.1833208,52.1631423 L79.6502298,52.1631423 C80.2914752,50.1725795 80.7742953,48.1151695 81.091146,45.9983397 L77.1833208,45.9983397 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1305123,52.1111499 L73.1849667,52.1111499 L73.1849667,58.2759525 L77.092792,58.2759525 C77.092792,58.2759525 77.1229682,58.2239602 77.1305123,58.1942503 L77.1305123,52.1111499 L77.1305123,52.1111499 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41327755,58.2759525 L8.28338248,58.2759525 L8.28338248,52.1111499 L4.33029285,52.1111499 L4.33029285,58.1348305 C4.3604691,58.1793953 4.3831013,58.2239602 4.41327755,58.2759525 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.430011659,45.9983397 L4.22467595,45.9983397 L4.22467595,39.8409647 L0.0528084494,39.8558196 L0.271586311,44.6465397 C0.32439476,45.0996155 0.362115081,45.5601188 0.430011659,46.0057672 L0.430011659,45.9983397 Z",
    id: "Path",
    strokeWidth: 0.735,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 25.104858)",
    fill: "#323237",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "101.792058 58.1645404 101.792058 56.5602062 11.7310198 56.5602062 11.7310198 59.8951416 101.792058 59.8951416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8875934,4.83528487 C90.5363144,4.83528487 84.1615801,9.11350926 84.1615801,16.5632646 C84.1615801,22.8469067 89.9705096,27.281108 97.7559838,27.281108 C103.685618,27.281108 108.596804,23.0548759 110,20.3958406 C110,19.5639636 109.155065,19.2222999 108.370482,19.2222999 C107.012551,21.2797099 103.180166,22.8469067 101.603457,22.7874869 C92.1733763,22.4458231 90.6494753,18.7320867 90.5363144,14.8475184 C90.3628009,10.6138588 94.9948563,6.95211465 98.9404019,7.23435862 C101.241341,7.40519049 102.048556,11.1189269 104.062821,12.4558721 C104.696523,12.7975358 106.160071,12.738116 107.118167,12.5672842 C107.849942,12.4558721 109.818942,12.0102237 109.818942,10.3464698 C109.818942,8.95010486 108.06872,7.40519049 106.386393,6.40248165 C104.696523,5.63002447 100.916947,4.84271234 98.8800494,4.84271234 L98.8875934,4.83528487 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1595912,20.9454736 C43.1595912,24.391821 42.2618476,26.2264069 39.4328235,26.3898113 L39.5007201,26.9542992 C44.2308484,26.8948794 49.0364173,26.9542992 53.6609286,26.8428871 L53.7137371,26.5606431 C51.5787669,26.5606431 49.9341609,24.3324013 49.9341609,21.5693813 L49.9341609,12.2850402 C49.9341609,10.004806 52.7556409,8.55644879 54.6718332,8.72728067 C57.6592826,9.00209717 59.3038886,10.8886753 59.3038886,12.5598567 L59.3038886,21.673366 C59.3038886,24.4512408 58.4589534,26.1744145 56.2560867,26.3378189 L56.2560867,26.8428871 L69.2318771,26.8428871 L69.2318771,26.449231 C67.3081407,26.2264069 65.9577532,24.5032331 65.9577532,21.8961901 L65.9577532,12.3370325 C65.9577532,10.28705 67.7607846,8.89811255 70.9821,8.84612024 C73.80358,8.78670045 75.4934504,10.8515379 75.4934504,12.7901084 L75.4934504,21.4431143 C75.4934504,24.391821 74.5957067,26.2264069 72.3400315,26.449231 L72.3400315,26.8428871 C77.0777039,26.9023069 80.9628969,26.9023069 85.6477608,26.8428871 L85.6477608,26.5606431 C83.1733077,26.5606431 82.3283725,24.941454 82.3283725,21.5693813 L82.3283725,12.0027962 C82.3283725,8.83869276 80.5781496,5.05810905 75.6669639,5.05810905 C72.3400315,5.05810905 69.9032988,6.6624432 68.5076469,7.12294652 C67.5495508,7.50174764 66.870585,7.94739602 66.636719,7.94739602 C66.1991633,7.94739602 65.693711,7.67257952 65.0675537,7.00410696 C63.8755915,5.77114645 61.7406214,5.05810905 59.4774021,5.05810905 C56.5955696,5.05810905 53.7212811,6.6624432 52.3633496,7.12294652 C52.2049242,7.17493883 51.1864756,7.67257952 51.0657705,7.67257952 C50.8394486,7.67257952 49.941705,7.67257952 49.941705,7.56116742 C49.941705,4.89470465 50.1152184,6.2242223 50.0020575,4.33764418 L48.1386736,4.33764418 C47.5879569,4.33764418 46.6072286,5.34035302 45.4907071,5.77114645 C44.1327755,6.33563439 41.4244565,6.27621461 40.307935,6.55845858 L40.307935,8.4450367 L43.2350319,9.00209717 L43.2350319,12.6712688 L43.1822234,20.9454736 L43.1595912,20.9454736 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4629312,26.9023069 C35.4344695,26.6720552 40.2249503,25.6173541 40.2249503,20.9009088 C40.2249503,17.4619888 36.3925657,15.2857393 32.3338591,13.569993 C29.731157,12.5152919 25.9591249,10.96295 25.9591249,9.73741699 C25.9591249,8.29648724 28.8334133,5.51861237 31.6020849,7.7319993 L36.4001097,11.6834149 L38.6029765,11.2377665 L37.3657499,5.35520797 C36.2265963,5.40720028 35.4420136,5.46662006 31.3154105,4.79072003 C26.2307112,4.07025516 20.1954598,6.57331353 20.1954598,11.2377665 C20.1954598,14.3573051 24.7747068,16.5186998 28.3883136,17.9596295 C30.3573143,18.7915065 33.8653042,20.024467 33.8653042,21.9036176 C33.8653042,23.7827683 30.5911803,24.2432716 28.7277964,24.2432716 C25.5668336,24.2432716 22.0588437,20.0690318 22.0588437,20.0690318 L19.976682,20.0690318 L21.1007475,26.2932541 C21.4930389,25.9590178 22.911323,26.0110101 23.1979974,26.1298497 C24.208902,26.5086508 27.8753172,27.0731388 30.4629312,26.9097344 L30.4629312,26.9023069 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4980454,8.0068158 L18.4980454,5.11010136 L12.3571771,5.16952115 C11.5725945,5.16952115 11.6178589,5.00611674 11.6178589,4.0034079 L11.6857554,0.0519923104 L8.57760099,0 C7.61950484,2.10940231 6.43508676,3.49833974 5.76366504,3.77315624 L0,6.26878714 L0,8.05138064 L2.1500583,8.10337295 C3.11569851,8.10337295 3.50044579,8.05138064 3.50044579,9.1580741 L3.50044579,20.8786264 C3.50044579,24.4363859 5.4769906,27.0434289 10.5616899,27.1622684 C14.3865304,27.2736805 16.7101022,25.6024991 18.3396201,24.0427298 L17.8945203,22.5423803 C17.2080104,22.9880287 16.6572937,23.3816847 15.744462,23.3816847 C11.399081,23.3816847 11.519786,20.0467494 11.519786,17.0980426 L11.519786,9.1580741 C11.519786,7.99196085 11.6178589,7.99196085 12.4175297,7.99196085 L18.4980454,7.99196085 L18.4980454,8.0068158 Z",
    id: "Path"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPLogoTsmc);
export default __webpack_public_path__ + "static/media/p-logo-tsmc.36cd030608ffe30583e2e492b4b20543.svg";
export { ForwardRef as ReactComponent };